import { BoardContainer } from "./board-container/BoardContainer";
import { GameVars } from "./../../GameVars";
import { BoardScene } from "./BoardScene";
import { GameConstants } from "../../GameConstants";
import { BoardManager } from "./BoardManager";
import { AudioManager } from "../../AudioManager";

export class TutorialLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, type: string) {

        super(scene);

        const bckInput = new Phaser.GameObjects.Graphics(this.scene);
        bckInput.fillStyle(0x000000);
        bckInput.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        bckInput.alpha = .01;
        bckInput.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        bckInput.on("pointerdown", () => { 
            this.onTutorialDown(); 
        });
        this.add(bckInput);

        let bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000, .75);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        let renderTexture = new Phaser.GameObjects.RenderTexture(this.scene, 0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(renderTexture);

        renderTexture.draw(bck);

        let title = new Phaser.GameObjects.Image(this.scene, 20, 20, "texture_atlas_language", "how_to_play_title");
        title.setOrigin(0);
        this.add(title);

        let clickToContinue = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH - 20, GameConstants.GAME_HEIGHT - 20, "texture_atlas_language", "tutorial_click");
        clickToContinue.setOrigin(1);
        this.add(clickToContinue);

        if (type === GameConstants.TUTORIAL_1_1) {

            let height = 350;
            let width = 700;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(GameConstants.GAME_WIDTH / 2 - width / 2, GameConstants.GAME_HEIGHT / 2 - height / 2, width, height, 20);
            bckText.strokeRoundedRect(GameConstants.GAME_WIDTH / 2 - width / 2, GameConstants.GAME_HEIGHT / 2 - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[0];

            let textObject = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 40);
            this.add(textObject);
        } else if (type === GameConstants.TUTORIAL_1_2) {

            let bck2 = new Phaser.GameObjects.Graphics(this.scene);
            bck2.fillStyle(0x000000);
            bck2.fillRoundedRect(90, 600, 760, 280, 20);

            renderTexture.erase(bck2);

            let bck3 = new Phaser.GameObjects.Graphics(this.scene);
            bck3.lineStyle(10, 0x5E290E);
            bck3.strokeRoundedRect(90, 600, 755, 285, 20);

            renderTexture.draw(bck3);

            let height = 100;
            let width = 350;
            let x = 240;
            let y = 485;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[1];

            let textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);

            let arrow = new Phaser.GameObjects.Image(this.scene, x, y + 105, "texture_atlas_1", "tutorial_arrow");
            this.add(arrow);

            height = 70;
            width = 400;
            x = 650;
            y = 500;

            bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            text = GameVars.gameText.TUTORIAL[2];

            textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 10);
            this.add(textObject);

            arrow = new Phaser.GameObjects.Image(this.scene, x - 50, y + 90, "texture_atlas_1", "tutorial_arrow");
            this.add(arrow);

        } else if (type === GameConstants.TUTORIAL_1_3) {

            title.visible = false;
            
            let bck2 = new Phaser.GameObjects.Graphics(this.scene);
            bck2.fillStyle(0x000000);
            bck2.fillRoundedRect(10, 70, 300, 500, 20);

            renderTexture.erase(bck2);

            let bck3 = new Phaser.GameObjects.Graphics(this.scene);
            bck3.lineStyle(10, 0x5E290E);
            bck3.strokeRoundedRect(10, 70, 300, 500, 20);

            renderTexture.draw(bck3);

            bck2 = new Phaser.GameObjects.Graphics(this.scene);
            bck2.fillStyle(0x000000);
            bck2.fillRoundedRect(890, 330, 300, 500, 20);

            renderTexture.erase(bck2);

            bck3 = new Phaser.GameObjects.Graphics(this.scene);
            bck3.lineStyle(10, 0x5E290E);
            bck3.strokeRoundedRect(890, 330, 300, 500, 20);

            renderTexture.draw(bck3);

            bck2 = new Phaser.GameObjects.Graphics(this.scene);
            bck2.fillStyle(0x000000);
            bck2.fillRoundedRect(450, 10, 560, 280, 20);

            renderTexture.erase(bck2);

            bck3 = new Phaser.GameObjects.Graphics(this.scene);
            bck3.lineStyle(10, 0x5E290E);
            bck3.strokeRoundedRect(450, 10, 560, 280, 20);

            renderTexture.draw(bck3);

            let height = 100;
            let width = 250;
            let x = GameConstants.GAME_WIDTH / 2;
            let y = GameConstants.GAME_HEIGHT / 2;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[3];

            let textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);

            let arrow = new Phaser.GameObjects.Image(this.scene, x - 180, y, "texture_atlas_1", "tutorial_arrow");
            arrow.setAngle(90);
            this.add(arrow);

            arrow = new Phaser.GameObjects.Image(this.scene, x, y - 100, "texture_atlas_1", "tutorial_arrow");
            arrow.setAngle(180);
            this.add(arrow);

            arrow = new Phaser.GameObjects.Image(this.scene, x + 180, y, "texture_atlas_1", "tutorial_arrow");
            arrow.setAngle(270);
            this.add(arrow);

        } else if (type === GameConstants.TUTORIAL_1_4) {

            let bck2 = new Phaser.GameObjects.Graphics(this.scene);
            bck2.fillStyle(0x000000);
            bck2.fillRoundedRect(380, 530, 160, 120, 20);

            renderTexture.erase(bck2);

            let bck3 = new Phaser.GameObjects.Graphics(this.scene);
            bck3.lineStyle(10, 0x5E290E);
            bck3.strokeRoundedRect(380, 530, 160, 120, 20);

            renderTexture.draw(bck3); 

            let height = 100;
            let width = 550;
            let x = GameConstants.GAME_WIDTH / 2;
            let y = GameConstants.GAME_HEIGHT / 2 - 40;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[4];

            let textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);
        } else if (type === GameConstants.TUTORIAL_1_5) {
            
            clickToContinue.visible = false;
            bckInput.input.enabled = false;

            let bck2 = new Phaser.GameObjects.Graphics(this.scene);
            bck2.fillStyle(0x000000);
            bck2.fillRoundedRect(360, 320, 485, 565, 20);

            renderTexture.erase(bck2);

            let bck3 = new Phaser.GameObjects.Graphics(this.scene);
            bck3.lineStyle(10, 0x5E290E);
            bck3.strokeRoundedRect(360, 320, 485, 565, 20);

            renderTexture.draw(bck3); 

            let height = 220;
            let width = 320;
            let x = 180;
            let y = 430;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[5];

            let textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);

            height = 260;
            width = 320;
            x = 1025;
            y = 755;

            bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            text = GameVars.gameText.TUTORIAL[6];

            textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);

            let arrow = new Phaser.GameObjects.Image(this.scene, 505, 300, "texture_atlas_1", "tutorial_arrow");
            this.add(arrow);

            arrow = new Phaser.GameObjects.Image(this.scene, 695, 300, "texture_atlas_1", "tutorial_arrow");
            this.add(arrow);

            textObject = new Phaser.GameObjects.Text(this.scene, 505, 205, GameVars.gameText.TUTORIAL[16], {fontFamily: "HelveticaNeue", fontSize: "45px", color: "#fff6d6", align: "center"});
            textObject.setOrigin(.5);
            textObject.setStroke("#5E290E", 15);
            textObject.setLineSpacing(-15);
            this.add(textObject);

            this.scene.tweens.add({
                targets: textObject,
                alpha: 0,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: 1000,
                yoyo: true,
                repeat: -1
            });

            textObject = new Phaser.GameObjects.Text(this.scene, 695, 205, GameVars.gameText.TUTORIAL[17], {fontFamily: "HelveticaNeue", fontSize: "45px", color: "#fff6d6", align: "center"});
            textObject.setOrigin(.5);
            textObject.setStroke("#5E290E", 15);
            textObject.setLineSpacing(-15);
            this.add(textObject);

            this.scene.tweens.add({
                targets: textObject,
                alpha: 0,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: 1000,
                yoyo: true,
                repeat: -1
            });

        } else if (type === GameConstants.TUTORIAL_1_6) {

            clickToContinue.visible = false;
            bckInput.input.enabled = false;

            let bck2 = new Phaser.GameObjects.Graphics(this.scene);
            bck2.fillStyle(0x000000);
            bck2.fillRoundedRect(360, 320, 485, 565, 20);

            renderTexture.erase(bck2);

            let bck3 = new Phaser.GameObjects.Graphics(this.scene);
            bck3.lineStyle(10, 0x5E290E);
            bck3.strokeRoundedRect(360, 320, 485, 565, 20);

            renderTexture.draw(bck3); 

            let height = 220;
            let width = 320;
            let x = 180;
            let y = 500;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[7];

            let textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);

            let arrow = new Phaser.GameObjects.Image(this.scene, 300, 760, "texture_atlas_1", "tutorial_arrow");
            arrow.setAngle(270);
            this.add(arrow);

            textObject = new Phaser.GameObjects.Text(this.scene, 160, 760, GameVars.gameText.TUTORIAL[18], {fontFamily: "HelveticaNeue", fontSize: "45px", color: "#fff6d6", align: "center"});
            textObject.setOrigin(.5);
            textObject.setStroke("#5E290E", 15);
            textObject.setLineSpacing(-15);
            this.add(textObject);

            this.scene.tweens.add({
                targets: textObject,
                alpha: 0,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: 1000,
                yoyo: true,
                repeat: -1
            });
        } else if (type === GameConstants.TUTORIAL_1_7) {

            let height = 300;
            let width = 500;
            let x = GameConstants.GAME_WIDTH / 2 + 200;
            let y = GameConstants.GAME_HEIGHT / 2;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[8];

            let textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);
        } else if (type === GameConstants.TUTORIAL_2) {

            let bck2 = new Phaser.GameObjects.Graphics(this.scene);
            bck2.fillStyle(0x000000);
            bck2.fillRoundedRect(GameConstants.GAME_WIDTH / 2 - 75, 530, 150, 150, 20);

            renderTexture.erase(bck2);

            let bck3 = new Phaser.GameObjects.Graphics(this.scene);
            bck3.lineStyle(10, 0x5E290E);
            bck3.strokeRoundedRect(GameConstants.GAME_WIDTH / 2 - 75, 530, 150, 150, 20);

            renderTexture.draw(bck3);

            let height = 150;
            let width = 700;
            let x = GameConstants.GAME_WIDTH / 2;
            let y = GameConstants.GAME_HEIGHT / 2 - 70;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[9];

            let textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);

            height = 110;
            width = 650;
            x = 360;
            y = 810;

            bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            text = GameVars.gameText.TUTORIAL[10];

            textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "30px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);

        } else if (type === GameConstants.TUTORIAL_3) {

            let bck2 = new Phaser.GameObjects.Graphics(this.scene);
            bck2.fillStyle(0x000000);
            bck2.fillRoundedRect(GameConstants.GAME_WIDTH / 2 - 75, 530, 150, 150, 20);

            renderTexture.erase(bck2);

            let bck3 = new Phaser.GameObjects.Graphics(this.scene);
            bck3.lineStyle(10, 0x5E290E);
            bck3.strokeRoundedRect(GameConstants.GAME_WIDTH / 2 - 75, 530, 150, 150, 20);

            renderTexture.draw(bck3);

            let height = 270;
            let width = 700;
            let x = GameConstants.GAME_WIDTH / 2;
            let y = GameConstants.GAME_HEIGHT / 2 - 150;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[11];

            let textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 40);
            this.add(textObject);

            height = 150;
            width = 600;
            x = 330;
            y = 795;

            bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            bckText.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 20);
            this.add(bckText);

            text = GameVars.gameText.TUTORIAL[12];

            textObject = new Phaser.GameObjects.Text(this.scene, x, y, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 30);
            this.add(textObject);
        } else if (type === GameConstants.TUTORIAL_4_1) {

            let height = 350;
            let width = 700;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(GameConstants.GAME_WIDTH / 2 - width / 2, GameConstants.GAME_HEIGHT / 2 - height / 2, width, height, 20);
            bckText.strokeRoundedRect(GameConstants.GAME_WIDTH / 2 - width / 2, GameConstants.GAME_HEIGHT / 2 - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[13];

            let textObject = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 40);
            this.add(textObject); 

        } else if (type === GameConstants.TUTORIAL_4_2) {
            
            let height = 380;
            let width = 700;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(GameConstants.GAME_WIDTH / 2 - width / 2, GameConstants.GAME_HEIGHT / 2 - height / 2, width, height, 20);
            bckText.strokeRoundedRect(GameConstants.GAME_WIDTH / 2 - width / 2, GameConstants.GAME_HEIGHT / 2 - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[14];

            let textObject = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 40);
            this.add(textObject); 
        } else if (type === GameConstants.TUTORIAL_5) {

            let height = 270;
            let width = 530;

            let bckText = new Phaser.GameObjects.Graphics(this.scene);
            bckText.fillStyle(0xfff6d6);
            bckText.lineStyle(10, 0x5E290E);
            bckText.fillRoundedRect(GameConstants.GAME_WIDTH / 2 - width / 2, GameConstants.GAME_HEIGHT / 2 - height / 2, width, height, 20);
            bckText.strokeRoundedRect(GameConstants.GAME_WIDTH / 2 - width / 2, GameConstants.GAME_HEIGHT / 2 - height / 2, width, height, 20);
            this.add(bckText);

            let text = GameVars.gameText.TUTORIAL[15];

            let textObject = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
            textObject.setOrigin(.5);
            textObject.setWordWrapWidth(width - 40);
            this.add(textObject);  
        }
    }

    private onTutorialDown(): void {

        AudioManager.playSound("click");

        BoardScene.currentInstance.removeTutorial();

        if (GameVars.tutorialCount === 1) {
            BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_1_2);
            GameVars.tutorialCount = 2;
        } else if (GameVars.tutorialCount === 2) {
            BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_1_3);
            GameVars.tutorialCount = 3;
        } else if (GameVars.tutorialCount === 3) {
            BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_1_4);
            GameVars.tutorialCount = 4;
        } else if (GameVars.tutorialCount === 4) {
            BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_1_5);
            GameVars.tutorialCount = 5;
            BoardManager.nextTurn(false);
        } else if (GameVars.tutorialCount === 9) {
            BoardManager.selectAdversaryCard();
            GameVars.tutorialCount = 10;
        } else if (GameVars.tutorialCount === 11) {
            GameVars.tutorialCount = 12;
        } else if (GameVars.tutorialCount === 13) {
            GameVars.tutorialCount = 14;
        } else if (GameVars.tutorialCount === 15) {
            BoardContainer.currentInstance.showPoints();
            GameVars.tutorialCount = 16;
        } else if (GameVars.tutorialCount === 16) {
            BoardContainer.currentInstance.newHand();
        }

    }
}
